export const LOCAL_STOREAGE_KEY = 'wla_download_list';
